<template lang="pug">
    div.row.cf__addUsers(v-if="$store.state.isUserLoggedIn")
        div.container.indent
            div.formBlock.wh_bl
                div.wrapper.wd
                    div.msg__success.is-active(v-if="success" v-html="success")
                    div.msg__error.is-active(v-if="errors" v-html="errors")

                    div.titleForm Добавление нового пользователя
                    input-vue.wd50(name="Имя *" v-model="user.name")
                    input-vue.wd50(name="Эл. Почта *" v-model='user.email')
                    input-vue.wd50(name="Пароль" v-model='user.password')
                    input-vue.wd50(name="Повторите пароль" v-model='user.repeat_password')

                    div.titleForm Настройки
                    label.controlCheckbox.wd50.ml15
                        input#checkbox.checkbox(type='checkbox', v-model='user.status', true-value='1',  false-value='0', value='')
                        div.control__indicator
                        | Активировать аккаунт:
                        =' '
                        span(v-if="user.status === '1'") да
                        span(v-else) нет

                    div.buttons.section.is-right.ml10.mr10
                        button.btn.btn_large.border.btnSaveWord(@click="create") Сохранить

</template>

<script>
    import {mapState} from 'vuex'
    import UsersService from '@/services/Users';

    export default {
        name: "create-words",
        data() {
            return {
                user: {
                    name: '',
                    email: '',
                    password: '',
                    repeat_password: '',
                    status: 0,
                    user_can: 'admin'
                },
                success: null,
                errors: null
            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, document.getElementsByTagName('body').offsetTop);
            },
            async create() {
                this.errors = null;
                if (!this.user.name || !this.user.email || !this.user.password || !this.user.repeat_password) {
                    this.scrollTop();
                    return this.errors = 'Пожалуйста, заполните поля.';
                }
                if (this.user.password !== this.user.repeat_password) {
                    return this.errors = 'Введенные пароли не совпадают.';
                }
                try {
                    await UsersService.create({
                        name: this.user.name,
                        email: this.user.email,
                        password: this.user.password,
                        status: this.user.status,
                        user_can: this.user.user_can
                    });
                    this.scrollTop();
                    this.success = 'Вы успешно добавили пользователя!';
                    this.user.name = '';
                    this.user.email = '';
                    this.user.password = '';
                    this.user.repeat_password = '';
                    this.user.status = '';
                    this.user.user_can = '';
                    setTimeout(() => {
                        this.success = null;
                    }, 2000);
                } catch (error) {
                    this.errors = error.response.data.error
                }
            }
        },
        computed: {
            ...mapState(['isUserLoggedIn']),
        },
    }
</script>

